import { useIntl } from '@capsicum/common';
import { ActivityIndicator } from '@capsicum/common-web';
import {
	ACM,
	alayanspor,
	AlfaRomeo,
	alliance,
	Arsenal,
	ASRoma,
	AstonMartin,
	atletico,
	Barcelona,
	benfica,
	Cam,
	corinthians,
	davisCup,
	ENDCEX,
	flemengo,
	Galatasary,
	harlequin,
	hereditic,
	interMilan,
	johor,
	juventus,
	leeds,
	leicesterTigers,
	manchesterCity,
	mibr,
	og,
	plameras,
	psg,
	RFK,
	saracens,
	SFParis,
	sharks,
	Trrabzonspor,
	UFC,
	valencia
} from '@capsicum/features/onboard/shared';
import { motion } from 'framer-motion';
import { type FC, useState } from 'react';
import styled from 'styled-components';

import * as Components from './components.styled';
import { Shell } from './Shell';

const icons = [
	Barcelona,
	manchesterCity,
	Galatasary,
	ACM,
	psg,
	flemengo,
	atletico,
	Arsenal,
	Trrabzonspor,
	interMilan,
	benfica,
	corinthians,
	juventus,
	johor,
	Cam,
	valencia,
	leeds,
	alayanspor,
	ASRoma,
	plameras,
	UFC,
	AstonMartin,
	AlfaRomeo,
	RFK,
	davisCup,
	alliance,
	og,
	ENDCEX,
	hereditic,
	mibr,
	leicesterTigers,
	saracens,
	SFParis,
	sharks,
	harlequin
];

export const SecondPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const { $t } = useIntl();

	const [loaded, setLoaded] = useState(0);

	return (
		<Shell goBack={goBack} proceed={next}>
			<S.GridContainer>
				<S.ImageContainer>
					{icons.map(i => (
						<motion.div
							animate={{ opacity: loaded >= icons.length ? 1 : 0 }}
							initial={{
								flex: 1,
								justifyContent: 'center',
								opacity: 0,
								position: 'relative'
							}}
							key={i.src}
							transition={{ duration: 0.5 }}
						>
							<S.Image alt="partner-image" src={i} onLoad={() => setLoaded(j => ++j)} />
						</motion.div>
					))}
				</S.ImageContainer>
				{loaded < icons.length ? <S.Loader /> : null}
			</S.GridContainer>
			<Components.HeadlineText>
				{$t<JSX.Element>('onboarding.screen1Headline', {
					blue: chunks => <Components.Blue>{chunks}</Components.Blue>
				})}
			</Components.HeadlineText>
		</Shell>
	);
};

namespace S {
	export const ImageContainer = styled(Components.ImageWrapper)`
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		gap: 10px;
		flex-grow: 1;
		flex-shrink: 1;
		margin-left: ${({ theme }) => theme.spacings.xsmall};
		margin-right: ${({ theme }) => theme.spacings.xsmall};
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			margin-top: ${({ theme }) => theme.spacings.xxlarge};
		}
	`;

	export const GridContainer = styled.div`
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: center;

		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			align-items: stretch;
		}
	`;

	export const ImageGrid = styled.div`
		width: 100%;
		flex-direction: row;
		flex: 1;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const Image = styled(Components.Image)`
		${({ theme }) => theme.breakpoints.queries.above.mobile} {
			position: static;
			height: auto;
			width: auto;
			max-width: 100%;
			max-height: 100%;
			aspect-ratio: 1;
		}
	`;

	export const Loader = styled(ActivityIndicator)`
		position: absolute;
		top: calc(50% - (32px / 2));
		left: calc(50% - (32px / 2));
	`;
}
